import {isAdministratorOnlyRoute} from "../../../utils/routeAccess.js";

export function getSidebarRouteAccessibleLabel(route, t) {
    const parts = [route?.name];

    if (isAdministratorOnlyRoute(route)) {
        parts.push(t("route.administrator_only", {defaultValue: "Pouze pro administrátory"}));
    }

    if (route?.badgeCount > 0) {
        parts.push(t("admin.subscription_payments.pending_vat_reviews_badge", {
            defaultValue: "{{count}} čekajících rozhodnutí o DPH",
            count: route.badgeCount,
        }));
    }

    return parts.filter(Boolean).join(", ");
}
